import { render, staticRenderFns } from "./review-report-action.vue?vue&type=template&id=6746150b"
import script from "./review-report-action.vue?vue&type=script&lang=js"
export * from "./review-report-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports